import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button } from '@mui/material';
import ShippingProfile from '../components/ShippingProfile';
import { ShippingApi } from '../api/shippingApi';
import { getSerialNumber } from '../../../utils/sharedFunctions';
import { storeSorting } from '../../../config/sortingLabels';
import useListingActions from '../../../hooks/useListingActions';
import { ListingPage, ListTable, ListTableActions } from '../../../shared-components'

const ShippingProfileContainer = () => {
  const history = useHistory();
  const { store_id } = useParams();

  const {
    data,
    count,
    page,
    perPage,
    searchTerm,
    setData,
    sortOptionSelected,
    handlerForSearchingAndSortingChange,
  } = useListingActions(
    'shippingProfiles',
    (params) => ShippingApi.getShippingProfiles(store_id, params)
  );
  

  const deleteSingleShippingProfile = async (shippingProfile) => {
    await ShippingApi.removeShippingProfile(store_id, shippingProfile);
    setData(data.filter((profile) => profile.id !== shippingProfile.id));
  };

  const shippingProfileTableContent = () => {
    const shippingProfileBody = data?.map((shippingProfile, index) => (
      <ShippingProfile
        key={shippingProfile.id}
        {...shippingProfile}
        deleteShippingProfile={() => deleteSingleShippingProfile(shippingProfile)}
        index={getSerialNumber(page, perPage, index)}
      />
    ));
    return { body: shippingProfileBody, heading: ['Id', 'Name', 'Status', 'Actions'] };
  };

  const tableActions = (
    <ListTableActions
      searchText="Search Shipping Profiles"
      searchTerm={searchTerm}
      sortOptionSelected={sortOptionSelected}
      getData={handlerForSearchingAndSortingChange}
      sortOptions={storeSorting}
    />
  );

  const actions = (
    <Button
      color="primary"
      variant="contained"
      onClick={() => history.push(`/admin/stores/${store_id}/shipping-profiles/new`)}
    >
      Create Shipping Profile
    </Button>
  );

  const tableContent = shippingProfileTableContent();

  return (
    <ListingPage
      title="Shipping Profiles"
      actions={actions}
      table={
        <ListTable
          tableHeadings={tableContent.heading}
          tableContent={tableContent.body}
          tableActions={tableActions}
          count={count}
          page_no={page}
          rowsPerPage={perPage}
          onPageChange={(event, pageNo) => handlerForSearchingAndSortingChange('page', pageNo + 1)}
          handleChangeRowsPerPage={(event) => handlerForSearchingAndSortingChange('pageSize', event.target.value)}
          rowsControl={true}
        />
      }
    />
  );
};

export default ShippingProfileContainer;